// extracted by mini-css-extract-plugin
export default {"shortsContainer":"Shorts_shortsContainer__v4oCC","shortItem":"Shorts_shortItem__RQAqn","iframe":"Shorts_iframe__0AO2F"};